import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import styled, { keyframes } from 'styled-components';

interface ScrollAnimationWrapperProps {
  animationType: AnimationType;
  children?: JSX.Element | JSX.Element[] | string;
}

interface ScrollAnimationProps {
  animateIn?: string;
  animateOut?: string;
  offset?: number;
  duration?: number;
  animateOnce?: boolean;
}

interface AnimatedListItemProps {
  index: number;
}

export enum AnimationType {
  TitleSlideUp = 'TitleSlideUp',
  DefaultSlideUp = 'DefaultSlideUp',
  AnimatedList = 'AnimatedList',
}

const onScreenListClassName = 'onScreenList';

const scrollPropsFromAnimationType: { [key in AnimationType]: ScrollAnimationProps } = {
  [AnimationType.TitleSlideUp]: {
    animateIn: 'fadeInSlideUp',
    offset: 20,
    duration: 0.8,
    animateOnce: true,
  },
  [AnimationType.DefaultSlideUp]: {
    animateIn: 'fadeInSlideUp',
    offset: 50,
    duration: 0.8,
    animateOnce: true,
  },
  [AnimationType.AnimatedList]: {
    animateIn: onScreenListClassName,
    offset: 50,
    duration: 0.8,
    animateOnce: true,
  },
};

const fadeInSlideUp = keyframes`
    from {
        transform: translate(0, 200%);
        opacity: 0;
    }

    to {
        transform: translate(0, 0);
        opacity: 1;
    }
`;

const CssAnimationWrapper = styled.div`
  .fadeInSlideUp {
    animation-name: ${fadeInSlideUp};
  }

  .${onScreenListClassName} li {
    opacity: 0;
    animation-name: ${fadeInSlideUp};
    animation-duration: 0.8s;
    animation-fill-mode: forwards;
  }
`;

export const AnimatedListItem: React.SFC<AnimatedListItemProps> = (props) => {
  const delayPerItem = 0.15;
  const delay = props.index * delayPerItem;
  const style = {
    animationDelay: delay + 's',
  };

  return <div style={style}>{props.children}</div>;
};

const ScrollAnimationWrapper: React.SFC<ScrollAnimationWrapperProps> = (props) => {
  const scrollProps = scrollPropsFromAnimationType[props.animationType];

  return process.env.STORYBOOK_ENABLED ? (
    <>{props.children}</>
  ) : (
    <CssAnimationWrapper>
      <ScrollAnimation {...scrollProps}>{props.children}</ScrollAnimation>
    </CssAnimationWrapper>
  );
};

export default ScrollAnimationWrapper;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/ScrollAnimationWrapper.tsx